import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'FirearmTrace',
		url: '/firearm_traces',
		icon: 'firearm_trace',
	},
];


class Firearm_Traces extends Framework.Components.View {

	render() {
		let { locations, states, reloadShell} = this.props.rootState;
		return (
			<div className="container-fluid">

				<Collections.FirearmTrace
					history={this.props.history}
					locations={locations}
					states={states}
					reloadShell={reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>

			</div>
		);
	}
}

export default Framework.Components.withRootState(Firearm_Traces);